import { Box } from "@chakra-ui/react";
import { DropFileInProgress } from "domains/drop-file";
import { useProgressContext } from "lib/context/progressContext";

export const UploadFileInProgress = () => {
  const { progress } = useProgressContext();

  if (progress > 0) {
    return (
      <Box position={"relative"} height={(progress) ? '74px' : '15px'}>
        <DropFileInProgress percent={progress} />
      </Box>
    );
  }

  return null;
}
